import ComponentRegistry from './ComponentRegistry'

interface AdaptiveCardBodyProps {
  actionHandler(...args: unknown[]): unknown
  body: unknown[]
  document?: object
  notificationId: string
  preserveFirstChildSpacing?: boolean
  registerInputCallback?(...args: unknown[]): unknown
}

const AdaptiveCardBody = ({
  body,
  notificationId,
  preserveFirstChildSpacing,
  registerInputCallback,
  actionHandler,
  document: propDocument
}: AdaptiveCardBodyProps) => {
  return (
    <>
      {body.map((cardElement: any, index: any) => {
        const CardElement = ComponentRegistry.getComponent(cardElement.type)
        if (CardElement) {
          return (
            // @ts-expect-error
            <CardElement
              key={index}
              cardId={notificationId}
              {...cardElement}
              spacing={preserveFirstChildSpacing ? cardElement.spacing : index === 0 ? 'none' : cardElement.spacing}
              separator={
                preserveFirstChildSpacing ? cardElement.separator : index === 0 ? false : cardElement.separator
              }
              registerInputCallback={registerInputCallback}
              actionHandler={actionHandler}
              document={propDocument}
            />
          )
        } else {
          return <div key={index} />
        }
      })}
    </>
  )
}

AdaptiveCardBody.displayName = 'AdaptiveCardBody'

AdaptiveCardBody.defaultProps = {
  registerInputCallback: () => {}
}

export default AdaptiveCardBody
